import { useEffect, useState } from 'react';
import { useNotification } from '../Contexts/NotificationContext';

const BirthdayList = () => {
    const { setNotification } = useNotification();
    const [birthdayData, setBirthdayData] = useState([]);
    const [loading, setLoading] = useState(false);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchBirthdays = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${baseUrl}/painel/aniversariantes`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setBirthdayData(data.aniversariantes);
                } else {
                    throw new Error('Erro ao buscar aniversariantes');
                }
            } catch (error) {
                setNotification({
                    type: 'error',
                    message: error.message,
                    show: true,
                });
            } finally {
                setLoading(false);
            }
        };

        fetchBirthdays();
    }, []);

    if (loading)
        return (
            <div className="grid md:grid-cols-3 gap-8 opacity-20">
                {[...Array(3)].map((_, index) => (
                    <div
                        key={index}
                        role="status"
                        className="flex items-center justify-center h-0 pb-[60%] bg-gray-300 rounded-lg animate-pulse dark:bg-gray-700"
                    >
                        <span className="sr-only">Loading...</span>
                    </div>
                ))}
            </div>
        );

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {birthdayData.map((monthData) => (
                <div key={monthData.mes} className="relative rounded-xl border border-stroke bg-white px-5 py-6 shadow-default">
                    <h3 className="text-xl font-semibold mb-4">{monthData.mes}</h3>

                    <div className="flex flex-col">
                        <div className="grid grid-cols-2 rounded-sm bg-neutral-100 text-slate-700">
                            <div className="p-2.5">
                                <h5 className="text-sm font-medium uppercase">Nome</h5>
                            </div>
                            <div className="p-2.5 text-center">
                                <h5 className="text-sm font-medium uppercase">Data</h5>
                            </div>
                        </div>

                        {monthData.aniversarios.map((birthday, index) => (
                            <div
                                className={`grid grid-cols-2 border-b border-stroke 
                                    ${birthday.is_today ? 'bg-secondary text-white' : 'bg-white text-black'} 
                                    hover:bg-opacity-90`}
                                key={index}
                            >
                                <div className="p-2.5">
                                    <p className="font-medium">{birthday.nome}</p>
                                </div>
                                <div className="flex items-center justify-center p-2.5">
                                    <p className="font-medium">{birthday.data_nascimento}</p>
                                </div>
                            </div>
                        ))}

                        {monthData.aniversarios.length === 0 && (
                            <div className="p-4 text-center text-gray-500">Nenhum aniversariante neste mês</div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default BirthdayList;
